const SearchTermsSvg = ({
  height = 20,
  width = 20,
  viewBox = '0 0 20 20',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M15.8335 15.833L13.3335 13.333M8.33366 16.6663H5.9976C5.066 16.6663 4.5995 16.6663 4.24333 16.4849C3.92972 16.3251 3.67494 16.0698 3.51515 15.7562C3.3335 15.3997 3.3335 14.9333 3.3335 13.9998V5.99984C3.3335 5.06642 3.3335 4.59936 3.51515 4.24284C3.67494 3.92924 3.92972 3.67445 4.24333 3.51466C4.59985 3.33301 5.0669 3.33301 6.00033 3.33301H14.0003C14.9337 3.33301 15.3998 3.33301 15.7563 3.51466C16.0699 3.67445 16.3256 3.92924 16.4854 4.24284C16.6668 4.59901 16.6668 5.0655 16.6668 5.9971V8.33317M11.2502 14.1663C9.63933 14.1663 8.3335 12.8605 8.3335 11.2497C8.3335 9.63884 9.63933 8.33301 11.2502 8.33301C12.861 8.33301 14.1668 9.63884 14.1668 11.2497C14.1668 12.8605 12.861 14.1663 11.2502 14.1663Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default SearchTermsSvg;
